import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../firebase';
import { ChatMessage } from '../components/copilot/copilotApi';

const COLLECTION_NAME = 'chatHistory';
const MAX_MESSAGES = 100;

interface ChatHistoryDoc {
  messages: ChatMessage[];
  updatedAt: Timestamp;
  userId: string;
  userEmail: string;
}

export async function loadChatHistory(userId: string): Promise<ChatMessage[]> {
  try {
    const docRef = doc(db, COLLECTION_NAME, userId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data() as ChatHistoryDoc;
      return data.messages || [];
    }

    return [];
  } catch (error) {
    console.error('Error loading chat history:', error);
    return [];
  }
}

export async function saveChatHistory(
  userId: string,
  userEmail: string,
  messages: ChatMessage[]
): Promise<void> {
  try {
    const docRef = doc(db, COLLECTION_NAME, userId);
    const trimmedMessages = messages.slice(-MAX_MESSAGES);

    await setDoc(
      docRef,
      {
        messages: trimmedMessages,
        updatedAt: serverTimestamp(),
        userId,
        userEmail,
      },
      { merge: true }
    );
  } catch (error) {
    console.error('Error saving chat history:', error);
  }
}

export async function clearChatHistory(userId: string): Promise<void> {
  try {
    const docRef = doc(db, COLLECTION_NAME, userId);
    await setDoc(
      docRef,
      {
        messages: [],
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
  } catch (error) {
    console.error('Error clearing chat history:', error);
  }
}
